<template>
  <div class="feedback-group-inner" v-if="!hidden">
    <div class="evaluated-person">
      <div>{{evaluatedFirstName}} {{evaluatedLastName}}</div>
      <div>
        <label>
          <input type="checkbox" v-model="selfEvaluate" /> Sebahodnotenie
        </label>
      </div>
      <div>
        <a>
          <span class="ico-close-red" @click="removeAllRelations()"></span>
        </a>
      </div>
    </div>
    <table class="relations">
      <tbody>
        <tr v-for="relationType in relationTypes" :key="relationType.id">
          <td>
            <div class="persons">
              <span class="bold">{{relationType.name}}</span>

              <div class="list">
                <span
                  v-for="relation in myRelations.filter(r => r.roleId == relationType.id)"
                  :key="relation.id"
                  class="evaluating"
                >
                  {{ participantById[relation.evaluatingId] ?
                  participantById[relation.evaluatingId].customer.name + " " + participantById[relation.evaluatingId].customer.lastname
                  : "(Vymazaný účastník)" }}
                  <a
                    @click="removeRelation(relation.relationId, relation.relationUid)"
                  >
                    <span class="ico-close-red-small"></span>
                  </a>
                </span>
              </div>
            </div>
          </td>
          <td>
            <div class="custom-select">
              <select @change="handleAddEvaluating($event, evaluatedId, relationType.id)">
                <option disabled selected value="next">+ {{relationType.name}}</option>
                <option
                  v-for="evaluating in participants.filter(x => x.customer_id !== evaluatedId)"
                  :key="evaluating.id"
                  :value="evaluating.customer_id"
                >{{evaluating.customer.name}} {{evaluating.customer.lastname}}</option>
              </select>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { generateUUID } from "./uuid";

function initData() {
  return {
    hidden: false,
    deletedRelations: [],
    myRelations: this.relations.map(r => ({
      relationId: r.id,
      roleId: r.role_id,
      evaluatedId: r.evaluated_id,
      evaluatingId: r.evaluating_id
    }))
  };
}

export default {
  props: [
    "evaluatedId",
    "evaluatedFirstName",
    "evaluatedLastName",
    "relations",
    "participantById"
  ],
  data: function() {
    return initData.bind(this)();
  },
  computed: {
    ...mapState({
      relationTypes: function (state) {
        return state.feedback.relationTypes
      },
      participants: state => state.feedback.participants
    }),
    selfEvaluate: {
      get() {
        return this.myRelations.some(fr => fr.evaluatingId == this.evaluatedId);
      },
      set(val) {
        if (!!val) {
          // set to true - create new relation

          this.handleAddEvaluating(
            { target: { value: this.evaluatedId } },
            this.evaluatedId,
            null
          );
        } else {
          const relation = this.myRelations.find(
            fr => fr.evaluatingId == this.evaluatedId
          );
          this.removeRelation(relation.relationId);
        }
      }
    }
  },
  methods: {
    handleAddEvaluating(event, evaluatedId, roleId) {
      const evaluatingId = parseInt(event.target.value);
      if (isNaN(evaluatingId)) {
        return;
      }

      if (
        !this.myRelations.find(
          r =>
            r.evaluatedId == evaluatedId &&
            r.evaluatingId == evaluatingId &&
            r.roleId == roleId
        )
      ) {
        this.myRelations = [
          ...this.myRelations,
          { relationUid: generateUUID(), evaluatedId, evaluatingId, roleId }
        ];
      }

      event.target.value = "next";
    },
    removeRelation(relationId, relationUid) {
      if (typeof relationId !== "undefined") {
        this.deletedRelations = [...this.deletedRelations, relationId];
        this.myRelations = this.myRelations.filter(
          r => r.relationId !== relationId
        );
      }

      if (typeof relationUid !== "undefined") {
        this.myRelations = this.myRelations.filter(
          r => r.relationUid !== relationUid
        );
      }
    },
    removeAllRelations() {
      this.hidden = true;
      this.deletedRelations = [
        ...this.deletedRelations,
        ...this.myRelations.map(r => r.relationId)
      ];
    },
    resetData() {
      Object.assign(this.$data, initData.call(this));
    }
  }
};
</script>

<style lang="less" scoped>
.evaluating {
  padding: 2px;
  border: red 1px solid;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackEditRelationsEvaluated.vue